import { useLiquorShopsTable } from '../hooks/useLiquorShopsTable';
import { CommonDataList } from '../components/CommonDataList';

const LiquorShopsPage = () => {
  const { table, loading, error } = useLiquorShopsTable('src.services.liquor_shops_service');

  return (
    <CommonDataList
      table={table}
      loading={loading}
      error={error}
      title="酒屋リスト"
    />
  );
};

export default LiquorShopsPage